export default "__VITE_ASSET__mfmPAOKI__"